export class AgendaRenderer {
  constructor(elements) {
    this.elements = elements;
  }

  updateFilterPosition(headerHeight) {
    this.elements.filter.style.top = `${headerHeight}px`;
  }

  updateItems(activeItems, inactiveItems) {
    activeItems.forEach((item) => {
      item.classList.remove("d-none");
      item.classList.add("d-flex");
    });

    inactiveItems.forEach((item) => {
      item.classList.remove("d-flex");
      item.classList.add("d-none");
    });
  }

  updateMonths() {
    this.elements.filterMonths.forEach((month) =>
      month.classList.replace("d-block", "d-none")
    );
    this.elements.months.forEach((month) => month.classList.replace("d-flex", "d-none"));

    this.elements.months.forEach((month) => {
      const isActive = !!month.querySelector(".agenda-overview-item.d-flex");
      month.classList.replace(
        isActive ? "d-none" : "d-flex",
        isActive ? "d-flex" : "d-none"
      );

      if (isActive) {
        Array.from(this.elements.filterMonths).forEach((filterMonth) => {
          const isMatchingMonth =
            filterMonth.dataset.month === month.dataset.month &&
            filterMonth.dataset.year === month.dataset.year;

          if (isMatchingMonth)
            filterMonth.classList.replace("d-none", "d-block");
        });
      }
    });
  }

  updateNoItemsMessage(hasItems) {
    this.elements.noItems.classList.toggle("d-none", hasItems);
    this.elements.noItems.classList.toggle("d-block", !hasItems);
  }

  updateRightMargin() {
    const activeMonths = Array.from(this.elements.filterMonths).filter((month) => {
      month.style.marginRight = 0;
      return month.classList.contains("d-block");
    });

    if (activeMonths.length > 0) {
      activeMonths[activeMonths.length - 1].style.marginRight = "50vw";
    }
  }
}
